var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5031_18461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5031_18461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99915 11.0623L6.58248 14.479C6.42971 14.6318 6.2561 14.7047 6.06165 14.6978C5.86721 14.6908 5.6936 14.6109 5.54082 14.4582C5.38804 14.3054 5.31165 14.1283 5.31165 13.9269C5.31165 13.7255 5.38804 13.5484 5.54082 13.3957L8.93665 9.99984L5.51998 6.58317C5.36721 6.43039 5.29429 6.25331 5.30123 6.05192C5.30818 5.85053 5.38804 5.67345 5.54082 5.52067C5.6936 5.36789 5.87068 5.2915 6.07207 5.2915C6.27346 5.2915 6.45054 5.36789 6.60332 5.52067L9.99915 8.93734L13.4158 5.52067C13.5686 5.36789 13.7457 5.2915 13.9471 5.2915C14.1485 5.2915 14.3255 5.36789 14.4783 5.52067C14.6311 5.67345 14.7075 5.85053 14.7075 6.05192C14.7075 6.25331 14.6311 6.43039 14.4783 6.58317L11.0617 9.99984L14.4783 13.4165C14.6311 13.5693 14.7075 13.7429 14.7075 13.9373C14.7075 14.1318 14.6311 14.3054 14.4783 14.4582C14.3255 14.6109 14.1485 14.6873 13.9471 14.6873C13.7457 14.6873 13.5686 14.6109 13.4158 14.4582L9.99915 11.0623Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b4081fea844c7bb0af3a09c347e562eb.svg";
export { ForwardRef as ReactComponent };